import * as React from 'react';

import { PAGE_CONTENT_CLASSNAME } from '../../../../containers/Editor/constants';

interface ContentProps {
	page: number;
	html: string;
	onLoad: (page: number) => void;
}

const Content = ({ page, html, onLoad }: ContentProps) => {
	const element = React.useRef<HTMLDivElement>(null);

	const addDOMLoadedObserver = (observer: MutationObserver): void => {
		observer.observe(element.current as HTMLDivElement, {
			childList: true,
		});
	};

	const removeDOMLoadedObserver = (observer: MutationObserver): void => {
		observer.disconnect();
	};

	React.useEffect(() => {
		const observer = new MutationObserver((mutationsList) => {
			for (let mutation of mutationsList) {
				const { type, addedNodes } = mutation;

				if (type === 'childList' && [...addedNodes].some(({ nodeName }) => nodeName === 'DIV')) {
					onLoad(page);
				}
			}
		});

		addDOMLoadedObserver(observer);

		return () => {
			removeDOMLoadedObserver(observer);
		};
	}, []);

	return (
		<div
			ref={element}
			className={PAGE_CONTENT_CLASSNAME}
			dangerouslySetInnerHTML={{ __html: html }}
			data-page={page}
		/>
	);
};

export default Content;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Page/Content/index.tsx